// extracted by mini-css-extract-plugin
export default {"heading":"CQcq8DFcyXiRv70WBtEE"};